import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between",
      "margin-bottom": "20px"
    }
  }, [_c("div"), _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("a-select", {
    staticStyle: {
      "margin-right": "20px",
      width: "200px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("部门"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption,
      allowClear: ""
    },
    model: {
      value: _vm.form.structureId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "structureId", $$v);
      },
      expression: "form.structureId"
    }
  }, _vm._l(_vm.resourceList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.getDataFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))])], 1)]), _vm.data.length > 0 ? _c("a-table", {
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.data,
      bordered: "",
      pagination: false,
      defaultExpandAllRows: true,
      showHeader: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function (text, record) {
        return [_c("span", {
          staticStyle: {
            "margin-right": "5px",
            cursor: "pointer"
          },
          style: record.operatingState ? "font-weight: bold;" : "",
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return (() => _vm.$router.push({
                name: "companyInfoCustomer",
                params: {
                  id: record.id
                }
              })).apply(null, arguments);
            }
          }
        }, [_vm._v(_vm._s(text))]), record.orgTypeName ? _c("a-tag", {
          attrs: {
            color: "green"
          }
        }, [_vm._v(_vm._s(record.orgTypeName))]) : _vm._e(), _vm.isAuth("customer.companyStructureStore") ? _c("i", {
          staticClass: "el-icon-circle-plus-outline",
          staticStyle: {
            "font-size": "16px",
            "margin-right": "5px",
            cursor: "pointer"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return (() => _vm.addDepartment(record, true)).apply(null, arguments);
            }
          }
        }) : _vm._e(), !record.operatingState && _vm.isAuth("customer.companyStructureEdit") ? _c("i", {
          staticClass: "el-icon-edit-outline",
          staticStyle: {
            "font-size": "16px",
            "margin-right": "5px",
            cursor: "pointer"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return (() => _vm.addDepartment(record, false)).apply(null, arguments);
            }
          }
        }) : _vm._e(), !record.operatingState && _vm.isAuth("customer.companyStructureDelete") ? _c("i", {
          staticClass: "el-icon-delete",
          staticStyle: {
            "font-size": "16px",
            cursor: "pointer"
          },
          on: {
            click: function ($event) {
              $event.stopPropagation();
              return (() => _vm.delDepartment(record)).apply(null, arguments);
            }
          }
        }) : _vm._e()];
      }
    }, {
      key: "framework",
      fn: function (text, record) {
        return [_c("div", {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "justify-content": "center",
            cursor: "pointer"
          },
          on: {
            click: function ($event) {
              return _vm.goFrameworkFun(record);
            }
          }
        }, [record.operatingState ? _c("span", {
          staticStyle: {
            "font-weight": "bold",
            "margin-right": "5px"
          }
        }, [_vm._v(_vm._s(_vm.$t("架构图")))]) : _vm._e(), _c("svg-icon", {
          attrs: {
            icon: "jiagou",
            size: 21
          }
        })], 1)];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [!record.operatingState ? _c("div", [record.status == 1 && _vm.isAuth("customer.companyStructureStatus") ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDeactivate(record, true);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("停用")))]) : _vm._e(), record.status == 0 && _vm.isAuth("customer.companyStructureStatus") ? _c("a-button", {
          attrs: {
            type: "add",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleEnable(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("启用")))]) : _vm._e()], 1) : _c("div", {
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(_vm.$t("操作")))])];
      }
    }], null, false, 1096317133)
  }) : _vm._e(), _vm.companyShow ? _c("company-model", {
    ref: "companyForm",
    on: {
      cancel: function ($event) {
        _vm.companyShow = false;
      },
      ok: _vm.getDataFun
    }
  }) : _vm._e(), _vm.deactivateShow ? _c("deactivate-model", {
    ref: "deactivateForm",
    on: {
      cancel: function ($event) {
        _vm.deactivateShow = false;
      },
      ok: _vm.getDataFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };